module.exports = __webpack_public_path__ + "img/srnn.2b134848.png";